import { MODULES_NAMES } from '../index';
export const { RICH_TEXT: MODULE_NAME } = MODULES_NAMES;

export const DATA_SOURCE_DISPLAY = {
	SAMPLE: { id: 'SAMPLE', displayText: 'Sample Only' },
	SOURCE: { id: 'SOURCE', displayText: 'Source Only' },
	SAMPLE_AND_SOURCE: { id: 'SAMPLE_AND_SOURCE', displayText: 'Source And Sample' },
};
